import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useForm } from 'react-hook-form';
import Checkbox from '@mui/material/Checkbox';
import SearchIcon from '@mui/icons-material/Search';
import PersonIcon from '@mui/icons-material/Person';
import InputAdornment from '@mui/material/InputAdornment';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import MenuItem from '@mui/material/MenuItem';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import EventIcon from '@mui/icons-material/Event';
import { Autocomplete } from '@mui/material';
import axios from 'axios';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import addCommas from '../../utils/functions/commas';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Grid from '@mui/material/Grid';
import { startOfMonth, subMonths, format } from 'date-fns';
import * as XLSX from 'xlsx';
import { styled } from '@mui/material/styles'; // 1. ต้อง import 'styled'
import SortableTableLabel from '../../components/Table/SortableTableLabel';


const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#fff', // หรือ theme.palette.action.hover ถ้าต้องการ
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },

  // [ปรับปรุง] ย้าย :hover มาไว้ที่นี่
  '&:hover': {
   
    boxShadow: '0 6px 16px rgba(0,0,0,0.12)',
    position: 'relative',
    zIndex: 10,
    cursor: 'pointer', // เพิ่ม cursor เพื่อให้รู้ว่า hover ได้
  },
  transition: 'transform 0.15s ',
}));

function SearchBankAndTableReportUnMatch({t}) {
  const [selectBank, setSelectBank] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [total, setTotal] = useState(0);
  const [sortBy, setSortBy] = useState('account_no');
  const [sortOrder, setSortOrder] = useState('asc');
  const [startDate, setStartDate] = useState('');

  const [endDate, setEndDate] = useState('');

  const [bankData, setBankData] = useState([]);

  const [groupBank, setGroupBank] = useState([]);

   

  const customCellHeader = {
    whiteSpace: 'nowrap',
    backgroundColor: '#4caf50', // ใช้โทน MUI primary
    color: 'white',
    padding: '12px',
    fontWeight: 'bold',
    fontSize: '13px',
  };

    const customCellData = {
    whiteSpace: 'nowrap',
    fontSize: '12px',
    padding: '10px',
    borderBottom: '1px solid #e0e0e0',
  };


  const columns = [
    { id: 'bookbank', label: t('app.bookbankNoStatment') },
    { id: 'transaction_date', label: t('app.dateTime') },
    { id: 'balance', label: t('app.totalThb') },
    { id: 'description', label: t('app.description') },
  ];

  const handleStatusCheckBox = (event) => {
    if (event.target.value) {
      setSelectStatus(event.target.value);
    } else {
      setSelectStatus('');
    }
  };
  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    setRowsPerPage(newRowsPerPage);
    setPage(0); // ตั้งค่าหน้าเริ่มต้นเป็นหน้าที่ 0 เมื่อเปลี่ยนแถวต่อหน้า
  };
  const handleRequestSort = (property) => {
    setSortOrder(
      sortBy === property && sortOrder === 'asc' ? 'desc' : 'asc',
    );
    setSortBy(property);
    setPage(0);
  };

  const fetchBankData = async () => {
    try {
      const bookBankParam =
        selectBank?.bank_name && selectBank?.account_no
          ? `&bookbank=${selectBank.bank_name}-${selectBank.account_no}`
          : '';

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL_admin}/matchstatement/bank-statement?page=${page + 1}&size=${rowsPerPage}${bookBankParam}&start_date=${startDate}&end_date=${endDate}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      );
      const result = response.data.data[0];
      const data = result.data;

      // console.log('ข้อมูลที่ได้รับจาก API:', data.data);

      setBankData(data); // เปลี่ยน responseData เป็น data
      setTotal(result.metadata?.[0]?.total || 0);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    // กำหนดค่าเริ่มต้นสำหรับ startDate และ endDate
    const initialStartDate = dayjs()
      .subtract(1, 'month')
      .startOf('month')
      .format('YYYY-MM-DD');
    const initialEndDate = dayjs().format('YYYY-MM-DD');
    setStartDate(initialStartDate);
    setEndDate(initialEndDate);
  }, []);

  useEffect(() => {
    if (startDate && endDate) {
      fetchBankData();
    }
  }, [startDate, endDate, selectBank, page, rowsPerPage, sortBy, sortOrder]);

  useEffect(() => {
    const fetchGroupBank = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL_admin}/matchstatement/group-bank-acc`,
        );
        const dataGroupBank = response?.data.data;

        // console.log('ข้อมูลที่ได้รับจาก API:', data.data);

        setGroupBank(dataGroupBank); // เปลี่ยน responseData เป็น data
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchGroupBank();

    // Cleanup function
    return () => {
      //
    };
  }, []);

  const handleExport = () => {
    const customData = bankData.map((row) => ({
      BookBank: row.bookbank,
      DateTime: row.transaction_date,
      Total: row.balance,
      Description: row.description,
    }));
    const ws = XLSX.utils.json_to_sheet(customData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'ReportBankStatement');
    XLSX.writeFile(wb, 'ReportBankStatement.xlsx');
  };

  return (
    <div>
      {' '}
      <div className="border-2 border-gray-300 xl:h-[300px] p-5  ">
        <div className="grid cols-1 xl:grid-cols-2 gap-5">
          <div>
            {t('app.bookbookbankNo' )}
            <div>
              <Autocomplete
                options={groupBank}
                getOptionLabel={(option) =>
                  `${option.bank_name}-${option.account_no}`
                }
                onChange={(event, newValue) => {
                  setSelectBank(newValue);
                  // console.log('Selected customer:', newValue);
                }}
                disablePortal
                size="small"
                id="combo-box-demo"
                sx={{ width: '100%' }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={(t('app.selectBankAccount'))}
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <InputAdornment position="start">
                          <AccountBalanceIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </div>
          </div>{' '}
          <div className=" ">
            {' '}
           {t('app.depositDate')}
            <div>
              <TextField
                type="date"
                id="outlined-basic"
                variant="outlined"
                sx={{ width: '100%' }}
                size="small"
                value={startDate}
                onChange={handleStartDateChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EventIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </div>{' '}
          <div>
             {t('app.toDate')}
            <div>
              <TextField
                type="date"
                id="outlined-basic"
                variant="outlined"
                sx={{ width: '100%' }}
                size="small"
                value={endDate}
                onChange={handleEndDateChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EventIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </div>
        </div>
        <div className="flex mt-5 justify-end ">
          <div>
            <Button
              variant="contained"
              sx={{ color: 'white' }}
              onClick={handleExport}
            >
              <FileDownloadIcon /> {t('app.export')}
            </Button>
          </div>
        </div>
      </div>
      <div className="mt-5  border-0  md:border-2 w-[100%]">
        <div>
          <TableContainer sx={{ maxHeight: 300 }}>
            <Table size='small'>
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell key={column.id} align="center" sx={customCellHeader}>
                      <SortableTableLabel
                        column={column}
                        sortBy={sortBy}
                        sortOrder={sortOrder}
                        onSort={handleRequestSort}
                        color="white"
                      />
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {_.size(bankData) ? (
                <TableBody>
                  {bankData.map((row, index) => (
                    <StyledTableRow
                      key={index}
                    >
                      <TableCell align="center" sx={customCellData }>{row.bookbank}</TableCell>
                      <TableCell align="center"sx={customCellData }>
                        {dayjs(row.transaction_date).format(
                          'DD/MM/YYYY HH:mm:ss',
                        )}
                      </TableCell>
                      <TableCell align="center"sx={customCellData }>
                        {addCommas(row.balance)}
                      </TableCell>
                      <TableCell align="center"sx={customCellData }>{row.description}</TableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              ) : (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <div>ไม่มีข้อมูล</div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 15]}
            component="div"
            count={total}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage} // จัดตำแหน่ง pagination ไปทางขวา
          />
        </div>
      </div>
    </div>
  );
}

export default SearchBankAndTableReportUnMatch;
